// src/pages/admin/AdminBatismo.js

import React, { useEffect, useState } from 'react';
import { getTurmasBatismo, createTurmaBatismo, updateTurmaBatismo, deleteTurmaBatismo,
         getInscricoesBatismo, updateStatusBatismo } from '../../services/api';
import { formatDate } from '../../utils/helpers';
import Toast from '../../components/common/Toast';
import PrintFichasBatismo from '../../components/admin/PrintFichasBatismo';

const STATUS_OPTIONS = ['Pendente', 'Confirmado', 'Cancelado', 'Realizado'];
const initialTurma = { nome: '', reuniao1: '', reuniao2: '', reuniao3: '', reuniao4: '', dataBatismo: '' };

const AdminBatismo = () => {
  const [turmas, setTurmas] = useState([]);
  const [inscricoes, setInscricoes] = useState([]);
  const [aba, setAba] = useState('turmas');
  const [showForm, setShowForm] = useState(false);
  const [showPrint, setShowPrint] = useState(false);
  const [turmaForm, setTurmaForm] = useState(initialTurma);
  const [editId, setEditId] = useState(null);
  const [toast, setToast] = useState(null);
  const [saving, setSaving] = useState(false);

  const loadTurmas = () => getTurmasBatismo().then(r => setTurmas(r?.data || [])).catch(() => {});
  const loadInscricoes = () => getInscricoesBatismo().then(r => setInscricoes(r?.data || [])).catch(() => {});

  useEffect(() => { loadTurmas(); loadInscricoes(); }, []);

  const handleSaveTurma = async (e) => {
    e.preventDefault();
    if (!turmaForm.nome.trim()) return;
    setSaving(true);
    try {
      if (editId) {
        await updateTurmaBatismo({ ...turmaForm, id: editId });
        setToast({ msg: 'Turma atualizada!', type: 'success' });
      } else {
        await createTurmaBatismo(turmaForm);
        setToast({ msg: 'Turma criada!', type: 'success' });
      }
      setTurmaForm(initialTurma);
      setEditId(null);
      setShowForm(false);
      loadTurmas();
    } catch {
      setToast({ msg: 'Erro ao salvar turma.', type: 'error' });
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteTurma = async (id) => {
    if (!window.confirm('Excluir esta turma?')) return;
    try {
      await deleteTurmaBatismo(id);
      setToast({ msg: 'Turma excluída.', type: 'success' });
      loadTurmas();
    } catch {
      setToast({ msg: 'Erro ao excluir.', type: 'error' });
    }
  };

  const handleEditTurma = (t) => {
    setTurmaForm({
      nome:        t.nome        || '',
      reuniao1:    t.reuniao1    || '',
      reuniao2:    t.reuniao2    || '',
      reuniao3:    t.reuniao3    || '',
      reuniao4:    t.reuniao4    || '',
      dataBatismo: t.dataBatismo || '',
    });
    setEditId(t.id);
    setShowForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleStatus = async (id, status) => {
    try {
      await updateStatusBatismo(id, status);
      setToast({ msg: 'Status atualizado!', type: 'success' });
      loadInscricoes();
    } catch {
      setToast({ msg: 'Erro ao atualizar status.', type: 'error' });
    }
  };

  const cancelar = () => {
    setShowForm(false);
    setEditId(null);
    setTurmaForm(initialTurma);
  };

  const pendentesCount = inscricoes.filter(i => i.status === 'Pendente').length;

  const tabStyle = (active) => ({
    padding: '0.75rem 1.5rem', border: 'none', cursor: 'pointer',
    borderBottom: active ? '3px solid var(--gold)' : '3px solid transparent',
    background: 'transparent', fontWeight: active ? 700 : 400,
    color: active ? 'var(--navy)' : 'var(--gray-400)',
    fontFamily: 'var(--font-body)', fontSize: '0.9rem', transition: 'all 0.15s',
  });

  return (
    <div style={{ padding: 'var(--space-2xl)' }}>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}

      {/* Modal de impressão */}
      {showPrint && (
        <PrintFichasBatismo
          inscricoes={inscricoes}
          turmas={turmas}
          onClose={() => setShowPrint(false)}
        />
      )}

      <div style={{ marginBottom: 'var(--space-xl)' }}>
        <h2 style={{ marginBottom: '0.25rem' }}>Batismo</h2>
        <p style={{ color: 'var(--gray-400)', fontSize: '0.9rem' }}>Gerencie turmas e inscrições</p>
      </div>

      {/* Abas */}
      <div style={{ borderBottom: '1px solid var(--gray-200)', marginBottom: 'var(--space-xl)', display: 'flex' }}>
        <button style={tabStyle(aba === 'turmas')} onClick={() => setAba('turmas')}>Turmas ({turmas.length})</button>
        <button style={tabStyle(aba === 'inscricoes')} onClick={() => setAba('inscricoes')}>Inscrições ({inscricoes.length})</button>
      </div>

      {/* ── Turmas ── */}
      {aba === 'turmas' && (
        <>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 'var(--space-lg)' }}>
            <button className="btn btn-primary btn-sm" onClick={() => { cancelar(); setShowForm(true); }}>+ Nova Turma</button>
          </div>

          {showForm && (
            <div style={{ background: 'var(--white)', borderRadius: 'var(--radius-lg)', padding: 'var(--space-xl)', boxShadow: 'var(--shadow-md)', marginBottom: 'var(--space-xl)', border: '2px solid var(--gold-pale)' }}>
              <h3 style={{ marginBottom: 'var(--space-lg)', fontSize: '1rem' }}>{editId ? '✏️ Editar Turma' : '+ Nova Turma'}</h3>
              <form onSubmit={handleSaveTurma} noValidate>
                <div className="form-group">
                  <label className="form-label">Nome da Turma <span className="required">*</span></label>
                  <input value={turmaForm.nome} onChange={e => setTurmaForm(f => ({ ...f, nome: e.target.value }))}
                    className="form-input" placeholder="Ex: Junho 2026" required />
                </div>

                <h4 style={{ color: 'var(--navy)', marginBottom: 'var(--space-md)', fontSize: '0.9rem', borderBottom: '1px solid var(--gray-200)', paddingBottom: '0.5rem' }}>
                  Datas das Reuniões
                </h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 'var(--space-md)', marginBottom: 'var(--space-md)' }}>
                  {['reuniao1','reuniao2','reuniao3','reuniao4'].map((campo, i) => (
                    <div key={campo} className="form-group" style={{ margin: 0 }}>
                      <label className="form-label">{i + 1}ª Reunião</label>
                      <input type="date" className="form-input"
                        value={turmaForm[campo] || ''}
                        onChange={e => setTurmaForm(f => ({ ...f, [campo]: e.target.value }))} />
                    </div>
                  ))}
                </div>

                <div className="form-group" style={{ maxWidth: 200 }}>
                  <label className="form-label">Data do Batismo</label>
                  <input type="date" className="form-input"
                    value={turmaForm.dataBatismo || ''}
                    onChange={e => setTurmaForm(f => ({ ...f, dataBatismo: e.target.value }))} />
                </div>

                <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
                  <button type="button" className="btn btn-sm"
                    style={{ background: 'var(--gray-100)', color: 'var(--gray-600)' }}
                    onClick={cancelar}>Cancelar</button>
                  <button type="submit" className="btn btn-primary btn-sm" disabled={saving}>
                    {saving ? 'Salvando...' : editId ? 'Salvar' : 'Criar Turma'}
                  </button>
                </div>
              </form>
            </div>
          )}

          {turmas.length === 0 ? (
            <p style={{ color: 'var(--gray-400)', textAlign: 'center', padding: '3rem' }}>Nenhuma turma cadastrada.</p>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 'var(--space-lg)' }}>
              {turmas.map((t, i) => (
                <div key={i} style={{ background: 'var(--white)', borderRadius: 'var(--radius-lg)', padding: 'var(--space-lg)', boxShadow: 'var(--shadow-sm)', borderTop: '4px solid var(--gold)' }}>
                  <h4 style={{ marginBottom: '0.75rem' }}>{t.nome}</h4>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', marginBottom: '1rem' }}>
                    {[t.reuniao1, t.reuniao2, t.reuniao3, t.reuniao4].filter(Boolean).map((r, idx) => (
                      <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.82rem' }}>
                        <span style={{ color: 'var(--gray-400)' }}>{idx + 1}ª Reunião</span>
                        <strong>{formatDate(r)}</strong>
                      </div>
                    ))}
                    {t.dataBatismo && (
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', borderTop: '1px solid var(--gray-100)', paddingTop: '0.35rem', marginTop: '0.1rem' }}>
                        <span style={{ fontWeight: 600 }}>Batismo</span>
                        <strong style={{ color: 'var(--gold)' }}>{formatDate(t.dataBatismo)}</strong>
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <button className="btn btn-sm btn-navy" style={{ flex: 1 }} onClick={() => handleEditTurma(t)}>Editar</button>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDeleteTurma(t.id)}>✕</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* ── Inscrições ── */}
      {aba === 'inscricoes' && (
        <>
          {/* Botão imprimir */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 'var(--space-lg)' }}>
            <button
              onClick={() => setShowPrint(true)}
              disabled={pendentesCount === 0}
              style={{
                display: 'flex', alignItems: 'center', gap: '0.5rem',
                background: pendentesCount > 0 ? 'var(--navy)' : 'var(--gray-200)',
                color: pendentesCount > 0 ? 'white' : 'var(--gray-400)',
                border: 'none', borderRadius: 'var(--radius-md)',
                padding: '0.6rem 1.25rem', cursor: pendentesCount > 0 ? 'pointer' : 'not-allowed',
                fontSize: '0.875rem', fontWeight: 600, fontFamily: 'var(--font-body)',
                transition: 'all 0.15s',
              }}>
              🖨️ Imprimir Fichas Pendentes
              <span style={{
                background: pendentesCount > 0 ? 'var(--gold)' : 'var(--gray-300)',
                color: 'var(--navy)', borderRadius: '99px',
                padding: '0.1rem 0.5rem', fontSize: '0.8rem', fontWeight: 700,
              }}>{pendentesCount}</span>
            </button>
          </div>

          {inscricoes.length === 0 ? (
            <p style={{ color: 'var(--gray-400)', textAlign: 'center', padding: '3rem' }}>Nenhuma inscrição registrada.</p>
          ) : (
            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Turma</th>
                    <th>Criança</th>
                    <th>Responsável</th>
                    <th>Telefone</th>
                    <th>Tipo</th>
                    <th>Documentos</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {inscricoes.map((s, i) => (
                    <tr key={i}>
                      <td style={{ fontSize: '0.82rem' }}>{s.turmaNome || '—'}</td>
                      <td>
                        <strong style={{ fontSize: '0.875rem' }}>{s.nomeFilho}</strong>
                        {s.dataNascimento && <div style={{ fontSize: '0.75rem', color: 'var(--gray-400)' }}>{formatDate(s.dataNascimento)}</div>}
                      </td>
                      <td style={{ fontSize: '0.82rem' }}>
                        {[s.nomePai, s.nomeMae].filter(Boolean).join(' / ') || '—'}
                        {(s.nomePadrinho || s.nomeMadrina) && (
                          <div style={{ fontSize: '0.75rem', color: 'var(--gray-400)' }}>
                            Padrinhos: {[s.nomePadrinho, s.nomeMadrina].filter(Boolean).join(' / ')}
                          </div>
                        )}
                      </td>
                      <td style={{ fontSize: '0.82rem' }}>{s.telefone || '—'}</td>
                      <td>
                        <span className="badge badge-pending" style={{ fontSize: '0.72rem' }}>{s.opcao || '—'}</span>
                      </td>
                      <td style={{ fontSize: '0.82rem' }}>
                        {s.urlCertidao && <a href={s.urlCertidao} target="_blank" rel="noopener noreferrer" style={{ display: 'block', color: 'var(--navy)' }}>📄 Certidão</a>}
                        {s.urlDocPadrinhos && s.urlDocPadrinhos.split('|').map((url, idx) => url && (
                          <a key={idx} href={url} target="_blank" rel="noopener noreferrer" style={{ display: 'block', color: 'var(--navy)' }}>📄 Padrinho {idx + 1}</a>
                        ))}
                        {s.urlDocParticipantes && s.urlDocParticipantes.split('|').map((url, idx) => url && (
                          <a key={idx} href={url} target="_blank" rel="noopener noreferrer" style={{ display: 'block', color: 'var(--navy)' }}>📄 Participante {idx + 1}</a>
                        ))}
                      </td>
                      <td>
                        <select value={s.status || 'Pendente'}
                          onChange={e => handleStatus(s.id, e.target.value)}
                          className="form-select" style={{ fontSize: '0.8rem', padding: '0.35rem 0.5rem', minWidth: 110 }}>
                          {STATUS_OPTIONS.map(st => <option key={st} value={st}>{st}</option>)}
                        </select>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AdminBatismo;
